import { useEffect } from "react";
import { stripCanonicalTrailingSlash } from "../../../../../lib/copy/src/canonical-url.mjs";
import { candidateTree, type CandidateProps } from "../../../scripts/release-nine-component";

/** The same existing template and immutable card seed used by first-response HTML. */
export default function ReleaseNineLanding({ data }: { data: CandidateProps }) {
  useEffect(() => {
    document.documentElement.lang = data.language;
    document.title = data.title;
    const links = [...document.querySelectorAll<HTMLLinkElement>('link[rel="canonical"]')];
    const canonical = links.shift() || document.createElement("link");
    canonical.rel = "canonical";
    canonical.href = stripCanonicalTrailingSlash(data.canonical);
    if (!canonical.isConnected) document.head.append(canonical);
    links.forEach(link => link.remove());
  }, [data.canonical, data.language, data.title]);
  return candidateTree(data);
}
